import { createFileRoute } from '@tanstack/react-router'
import { OverviewPage } from '@/features/overview'

/** Home: S-01 Overview (Frontend §7.1). */
export const Route = createFileRoute('/_authed/')({
  component: OverviewPage,
})
